export type AvailabilityType = 'api' | 'integration' | 'both' | null;

export interface SavedQuery {
  id: string;
  name: string;
  description: string | null;
  sql_query: string;
  endpoint_slug: string;
  selected_columns: string[];
  filter_columns: string[];
  column_distributor: string | null;
  column_industry: string | null;
  availability_type: AvailabilityType;
  documentation_description: string | null;
  is_active: boolean;
  automation_enabled: boolean;
  automation_interval: AutomationInterval | null;
  automation_last_run: string | null;
  automation_next_run: string | null;
  integration_solace_enabled: boolean;
  integration_solace_broker_url: string | null;
  integration_solace_vpn_name: string | null;
  integration_solace_queue_name: string | null;
  integration_solace_username: string | null;
  integration_solace_password: string | null;
  integration_solace_interval: AutomationInterval | null;
  integration_solace_last_run: string | null;
  integration_solace_next_run: string | null;
  integration_sap_btp_enabled: boolean;
  integration_sap_btp_service_url: string | null;
  integration_sap_btp_client_id: string | null;
  integration_sap_btp_client_secret: string | null;
  integration_sap_btp_token_url: string | null;
  integration_sap_btp_api_path: string | null;
  integration_sap_btp_interval: AutomationInterval | null;
  integration_sap_btp_last_run: string | null;
  integration_sap_btp_next_run: string | null;
  created_by: number | null;
  created_by_name: string | null;
  created_by_email: string | null;
  created_at: string;
  updated_at: string;
}

export type AutomationInterval = '3h' | '6h' | '12h' | '24h';

export const AUTOMATION_INTERVALS: { value: AutomationInterval; label: string }[] = [
  { value: '3h', label: 'A cada 3 horas' },
  { value: '6h', label: 'A cada 6 horas' },
  { value: '12h', label: 'A cada 12 horas' },
  { value: '24h', label: 'A cada 24 horas' },
];

export interface CreateQueryRequest {
  name: string;
  description?: string;
  sql_query: string;
  endpoint_slug?: string;
  selected_columns?: string[];
  filter_columns?: string[];
  column_distributor?: string;
  column_industry?: string;
  availability_type?: AvailabilityType;
  documentation_description?: string;
  is_active?: boolean;
  automation_enabled?: boolean;
  automation_interval?: AutomationInterval;
  integration_solace_enabled?: boolean;
  integration_solace_broker_url?: string;
  integration_solace_vpn_name?: string;
  integration_solace_queue_name?: string;
  integration_solace_username?: string;
  integration_solace_password?: string;
  integration_solace_interval?: AutomationInterval;
  integration_sap_btp_enabled?: boolean;
  integration_sap_btp_service_url?: string;
  integration_sap_btp_client_id?: string;
  integration_sap_btp_client_secret?: string;
  integration_sap_btp_token_url?: string;
  integration_sap_btp_api_path?: string;
  integration_sap_btp_interval?: AutomationInterval;
}

export interface UpdateQueryRequest {
  name?: string;
  description?: string;
  sql_query?: string;
  endpoint_slug?: string;
  selected_columns?: string[];
  filter_columns?: string[];
  column_distributor?: string;
  column_industry?: string;
  availability_type?: AvailabilityType;
  documentation_description?: string;
  is_active?: boolean;
  automation_enabled?: boolean;
  automation_interval?: AutomationInterval;
  integration_solace_enabled?: boolean;
  integration_solace_broker_url?: string;
  integration_solace_vpn_name?: string;
  integration_solace_queue_name?: string;
  integration_solace_username?: string;
  integration_solace_password?: string;
  integration_solace_interval?: AutomationInterval;
  integration_sap_btp_enabled?: boolean;
  integration_sap_btp_service_url?: string;
  integration_sap_btp_client_id?: string;
  integration_sap_btp_client_secret?: string;
  integration_sap_btp_token_url?: string;
  integration_sap_btp_api_path?: string;
  integration_sap_btp_interval?: AutomationInterval;
}

export interface QueryExecutionResult {
  success: boolean;
  data: Record<string, unknown>[];
  columns: string[];
  rowCount: number;
  executionTime: number;
  error?: string;
}
